import React from 'react';
import {
  Card, Form, Col, Button,
} from 'react-bootstrap';
import { Fab } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';

import moment from 'moment';
import DownloadLink from '../common/DownloadLink';
import { mBStyles } from '../../helpers';

export default function ButtonsCard({
  can, projId, projNumber, originId, year, actions,
}) {
  return (
    <Fab event="click" mainButtonStyles={mBStyles}>
      <Card>
        <Card.Body>
          <Form.Group as={Col}>
            { can.Edit && <Button className="me-2" variant="outline-secondary" onClick={actions.onEdit}>Редактировать</Button> }
            { can.SendToPortf && <Button className="me-2" variant="outline-warning" onClick={actions.onSendPortf}>Отправить руководителю портфеля</Button> }
            { can.SendToHead && <Button className="me-2" variant="outline-warning" onClick={actions.onSendHeadSP}>Отправить руководителю СП</Button> }
            { can.HeadSendToExperts && <Button className="me-2" variant="outline-warning" onClick={actions.onSendExperts}>Отправить на ЭГ</Button> }
            { can.PortfReturn && <Button className="me-2" variant="outline-danger" onClick={actions.onReturnForRevisionPortf}>Вернуть на доработку</Button>}
            { can.HeadReturn && <Button className="me-2" variant="outline-danger" onClick={actions.onReturnForRevisionHead}>Вернуть на доработку</Button>}
            { can.ExpertsReturn && <Button className="me-2" variant="outline-danger" onClick={actions.onReturnForRevisionExpert}>Вернуть на доработку</Button>}
            { can.ExpertsApproveBySP && <Button className="me-2" variant="outline-warning" onClick={actions.onApproveExpert}>Одобрить</Button>}
            { can.ApproveFinal && <Button className="me-2" variant="success" onClick={actions.onApproveFinal}>Подписанный скан отчета</Button> }
            { can.Read && (
            <DownloadLink
              variant="outline-secondary"
              url={`/projs/${projId}/results/0/export?year=${year}`}
              filename={`Отчет о реализации проекта №${projNumber} за ${year} год от ${moment().format('DD.MM.YYYY')}.pdf`}
            >
              Сформировать PDF
            </DownloadLink>
            )}
          </Form.Group>
        </Card.Body>
      </Card>
    </Fab>
  );
}
